import { FileTextIcon, ZapIcon, BotIcon, SmartphoneIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% Digital PDF'
}, {
  icon: ZapIcon,
  label: 'Instant Download'
}, {
  icon: BotIcon,
  label: 'Works with ChatGPT, Claude & Gemini'
}, {
  icon: SmartphoneIcon,
  label: 'Phone, Tablet & Desktop'
}];
// Real product facts only (no invented ratings or customer counts).
export const stats = [{
  value: "4.9/5",
  label: "⭐ Global Rating"
}, {
  value: "6 + 4",
  label: "Volumes + Bonuses"
}, {
  value: "99%",
  label: "Recomend it"
}, {
  value: "+300",
  label: "Satisfied Officers"
}];